import { render, staticRenderFns } from "./evaluationScale.vue?vue&type=template&id=2f4b0c74&scoped=true"
import script from "./evaluationScale.vue?vue&type=script&lang=js"
export * from "./evaluationScale.vue?vue&type=script&lang=js"
import style0 from "./evaluationScale.vue?vue&type=style&index=0&id=2f4b0c74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b0c74",
  null
  
)

export default component.exports